'use client'

import { Check } from 'lucide-react'

import { typographyVariants } from '@ui/web/lib'
import cn from '@config/tailwind/cn'

interface PremiumBenefitListProps {
  className?: string
  /** Optional bold lead-in above the list, e.g. "Setelah terbuka, dapatkan:". */
  title?: string
  items: string[]
}

/**
 * The ticked benefit list both premium locks show.
 *
 * Always left-aligned, even inside a centred card: a checklist read down a ragged centre line is
 * markedly harder to scan than one with a straight left edge.
 */
export function PremiumBenefitList({ className, title, items }: PremiumBenefitListProps) {
  return (
    <div className={cn('srd:flex srd:w-full srd:flex-col srd:gap-2 srd:text-left', className)}>
      {title && (
        <p className={cn(typographyVariants({ variant: 'body-md' }), 'srd:font-bold srd:text-neutral-black')}>
          {title}
        </p>
      )}

      <ul className='srd:flex srd:flex-col srd:gap-1.5'>
        {items.map((item) => (
          <li key={item} className='srd:flex srd:items-start srd:gap-2'>
            <Check className='srd:text-blue-100 srd:mt-0.5 srd:size-4 srd:shrink-0' aria-hidden />
            <span className={cn(typographyVariants({ variant: 'body-md' }), 'srd:text-neutral-black')}>{item}</span>
          </li>
        ))}
      </ul>
    </div>
  )
}
